import api from "./api";

export const ModeloImpressaoService = {
  // buscarModelosImpressaoTicketPorProcesso: (idProcesso)=>{
  //   return api.get(`/processo/${idProcesso}/modelos-impressao`);
  // },
  // getModelosDisponiveis: (idTipo, idTicket) => {
  //   return api.get(`/ticket/buscar-modelos/${idTipo}/${idTicket}`);
  // },
  // getModeloImpressao: (idReferencia, idModelo, auxiliar=null) => {
  //   return api.get(`/ticket/impressao/${idReferencia}/${idModelo}${auxiliar ? `/auxiliar/${auxiliar}` : ''}`);
  // },
  gerarModeloImpressaoPorProcesso: (idProcesso, idTipoModelo, cpf=null) => {
    return api.get(`/processo/${idProcesso}/impressao/${idTipoModelo}${cpf? `/cpf/${cpf}` : ''}`);
  },
};
